import React, { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { UserList } from '@components/pages';

function UserManagement() {
  const { setPageName } = useOutletContext();

  useEffect(() => {
    setPageName('Usuarios');
  }, []);

  return (
    <section className="container-fluid">
      <article className="row card">
        <UserList />
      </article>
    </section>
  );
}

export default UserManagement;
